<div class="dropdown-card tenant-dropdown-card">
  <!-- Current tenant pinned at the top, regardless of search. -->
  @if (tenantStore.currentTenant(); as current) {
    <button class="dropdown-menu-item tenant-item" type="button" (click)="closed.emit()">
      <div class="tenant-item-logo">
        @if (current.configuration.publicLogoUrl) {
          <img [src]="current.configuration.publicLogoUrl" alt="" class="dropdown-tenant-logo">
        } @else {
          <img [ngSrc]="environment.applicationLogo" alt="" width="20" height="18" class="dropdown-tenant-logo">
        }
      </div>
      <span class="dropdown-tenant-name font-M">{{ current.configuration.name }}</span>
      <img src="assets/icons/blue-check.svg" alt="" class="check-icon">
    </button>
  }

  @if (tenants().length > 1) {
    <!-- Separator between the current tenant and the rest. -->
    <div class="dropdown-separator"></div>

    <!-- Search bar (only when >3 tenants total) -->
    @if (tenants().length > COLLAPSED_COUNT) {
      <div class="tenant-search">
        <app-text-input [input]="searchControl" [placeholder]="'menu.searchWorkspace' | translate"></app-text-input>
      </div>
    }

    <!-- Tenant list (excludes the current tenant) -->
    <div class="tenant-list">
      @for (t of visibleOthers(); track t.configuration.id) {
        <button class="dropdown-menu-item tenant-item" type="button" (click)="select(t)">
          <div class="tenant-item-logo">
            @if (t.configuration.publicLogoUrl) {
              <img [src]="t.configuration.publicLogoUrl" alt="" class="dropdown-tenant-logo">
            } @else {
              <img [ngSrc]="environment.applicationLogo" alt="" width="20" height="18" class="dropdown-tenant-logo">
            }
          </div>
          <span class="dropdown-tenant-name font-M">{{ t.configuration.name }}</span>
        </button>
      }
      @if (others().length === 0) {
        <div class="tenant-empty-state">{{ 'page.application.table.filters.noGlobalSearchResult' | translate }}</div>
      }

      <!-- See more / see less -->
      @if (others().length > COLLAPSED_COUNT) {
        <button class="dropdown-toggle-more" type="button" (click)="showAll.set(!showAll())">
          {{ (showAll() ? 'menu.seeLess' : 'menu.seeMore') | translate }}
        </button>
      }
    </div>
  }

  <!-- Separator before actions -->
  <div class="dropdown-separator"></div>

  <!-- Actions -->
  @if (canOpenWorkspaceSettings()) {
    <button class="dropdown-menu-item" type="button" (click)="goToWorkspaceSettings()">
      <img src="assets/icons/menu-gear-outline.svg" alt="" class="dropdown-item-icon filter-darkgrey">
      <span>{{ 'menu.workspaceSettings' | translate }}</span>
    </button>
  }

  <button class="dropdown-menu-item" type="button" (click)="createWorkspace()">
    <img src="assets/icons/plus.svg" alt="" class="dropdown-item-icon filter-darkgrey">
    <span>{{ 'menu.createWorkspace' | translate }}</span>
  </button>
</div>
